import { createFileRoute } from "@tanstack/react-router";

import ActionLog from "~/pages/Administration/ActionLog";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration/action-log")({
  staticData: ROUTE_STATIC.administration,
  component: ActionLog,
});
